import { KeyboardArrowDown, KeyboardArrowUp, MoreHoriz } from '@mui/icons-material';
import { Button, ButtonGroup, Divider, Menu, MenuItem, Paper, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { AppModels, AppState, LayoutGroup, LayoutItem, LayoutItemType, LayoutTitle, ProductAttrs, QuoteAttrs, QuoteItemAttrs, ServiceAttrs, brandNewQuoteItem, isLayoutGroup, isQuoteItem, isQuoteSeparator, isQuoteTitle, notEmptyString, quoteEditorSlice, quoteItemSelector, quoteItemSlice, quoteSelector, selectQuoteItems } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { MainViewLoader } from '../../libraries/MainViewLoader';
import { appStore, generateNewId } from '../../store';
import { SuperSearchInput } from '../SuperSearchInput';
import { ModelTextfield } from '../utils/ModelTextField';

export const ProjectQuote = (props: { quoteId: ModelId; }) => {
    return <MainViewLoader
        modelId={props.quoteId}
        selector={quoteSelector}
        path={'quote/' + props.quoteId}
        onModelLoaded={(quote: QuoteAttrs) => {
            appStore.dispatch(quoteEditorSlice.actions.init(quote));
        }}
    >
        <LoadedProjectQuote quoteId={props.quoteId} />
    </MainViewLoader>;
};

export const LoadedProjectQuote = (props: { quoteId: ModelId; }) => {

    const quote = useSelector((state: AppState) => quoteSelector.selectById(state, props.quoteId));
    const quoteItems = useSelector((state: AppState) => selectQuoteItems(state, props.quoteId));
    const layout = useSelector((state: AppState) => state.quoteEditor.layout);

    React.useEffect(() => {
        if (quoteItems.length == 0) {
            addUp(LayoutItemType.ITEM, [0]);
            /*
            appStore.dispatch(quoteItemSlice.actions.addOne({
                ...brandNewQuoteItem,
                id: newId(),
                quoteId: props.quoteId,
                order: 1
            }));
            */
        }
    }, []);
    /*
    React.useEffect(() => {
        normalizeLayout();
    }, [quoteItems]);

    const normalizeLayout = () => {

        let layoutCopy: LayoutGroup = { ...quote?.layout ?? { items: [] } };
        const quoteItemIds = new Set(quoteItems.map(p => p.id));

        const checkItems = (layoutGroup: LayoutGroup) => {
            for (let item of layoutGroup.items) {
                if (isQuoteItem(item)) {
                    quoteItemIds.delete(item.quoteItemId);
                }
                if (isLayoutGroup(item)) {
                    checkItems(item);
                }
            }
        };

        checkItems(layoutCopy);
        console.log('quoteItemIds', quoteItemIds);
        if (quoteItemIds.size) {
            layoutCopy.items = layoutCopy.items.concat(Array.from(quoteItemIds.values()).map(id => {
                return { quoteItemId: id };
            }));
        }
        console.log('layoutCopy', layoutCopy);
        appStore.dispatch(quoteEditorSlice.actions.updateLayout(layoutCopy));
    };
    */

    if (!quote) return <></>;
    const moveUp = (_location: number[]) => {

    };
    const moveDown = (_location: number[]) => {

    };

    const addUp = (type: LayoutItemType, location: number[]) => {
        console.log('add up', type, location);
        switch (type) {
            case LayoutItemType.ITEM:
                console.log('layout', layout);
                const newQuoteItem = {
                    ...brandNewQuoteItem,
                    id: generateNewId(),
                    quoteId: props.quoteId,
                    name: ''
                };
                let newLayout = { ...layout };
                let newLayoutItem: LayoutItem = {
                    quoteItemId: newQuoteItem.id
                };
                newLayout.items = newLayout.items.length == 0 ? [newLayoutItem] : newLayout.items.reduce((acc: LayoutItem[], curr: LayoutItem, index: number) => {
                    if (index === location[0]) {
                        acc.push(newLayoutItem);
                    }
                    acc.push(curr);
                    return acc;
                }, []);
                console.log('newlayout', newLayout);

                appStore.dispatch(quoteEditorSlice.actions.updateLayout(newLayout));
                appStore.dispatch(quoteItemSlice.actions.addOne(newQuoteItem));
                break;
            default: break;
        }
    };
    const addDown = (type: LayoutItemType, location: number[]) => {
        console.log('add down', type, location);
        switch (type) {
            case LayoutItemType.ITEM:
                console.log('layout', layout);
                const newQuoteItem = {
                    ...brandNewQuoteItem,
                    id: generateNewId(),
                    quoteId: props.quoteId,
                    name: ''
                };
                const newLayoutItem: LayoutItem = {
                    quoteItemId: newQuoteItem.id
                };
                let newLayout = { ...layout };
                newLayout.items = newLayout.items.length == 0 ? [newLayoutItem] : newLayout.items.reduce((acc: LayoutItem[], curr: LayoutItem, index: number) => {
                    acc.push(curr);
                    if (index === location[0]) {
                        acc.push(newLayoutItem);
                    }
                    return acc;
                }, []);
                console.log('newlayout', newLayout);
                appStore.dispatch(quoteEditorSlice.actions.updateLayout(newLayout));
                appStore.dispatch(quoteItemSlice.actions.addOne(newQuoteItem));
                break;
            default: break;
        }
    };
    React.useEffect(() => { console.log('layout', layout); }, [layout]);
    return <>
        <Typography>Quote # {quote.id}</Typography>
        <TableContainer component={Paper}>
            <Table size='small'>
                <TableHead>
                    <TableCell width={40}></TableCell>
                    <TableCell>Item</TableCell>
                    <TableCell width={100}>Quantité</TableCell>
                    <TableCell width={100}>Prix</TableCell>
                    <TableCell width={100}>Total</TableCell>
                </TableHead>
                <TableBody>
                    <QuoteGroup
                        group={layout}
                        layoutLocation={[]}
                        addDown={addDown}
                        addUp={addUp}
                        moveDown={moveDown}
                        moveUp={moveUp}
                    />
                </TableBody>
            </Table>
        </TableContainer>
    </>;
};

const QuoteGroup = (props: {
    group: LayoutGroup,
    layoutLocation: number[],
    moveUp: (location: number[]) => void,
    moveDown: (location: number[]) => void,
    addUp: (type: LayoutItemType, location: number[]) => void,
    addDown: (type: LayoutItemType, location: number[]) => void;
}) => {
    return props.group.items.map((p, index) => {
        if (isQuoteTitle(p)) return <QuoteTitle group={p} layoutLocation={props.layoutLocation.concat([index])} />;
        else if (isQuoteItem(p)) return <QuoteItem
            quoteItemId={p.quoteItemId}
            layoutLocation={props.layoutLocation.concat([index])}
            moveUp={props.moveUp}
            moveDown={props.moveDown}
            addUp={props.addUp}
            addDown={props.addDown}
        />;
        else if (isQuoteSeparator(p)) return <QuoteSeparator layoutLocation={props.layoutLocation.concat([index])} />;
        else if (isLayoutGroup(p)) return <QuoteGroup
            group={p}
            layoutLocation={props.layoutLocation.concat([index])}
            moveUp={props.moveUp}
            moveDown={props.moveDown}
            addUp={props.addUp}
            addDown={props.addDown} />;
        else return <></>;
    });
};
const QuoteTitle = (props: { group: LayoutTitle, layoutLocation: number[]; }) => {
    return <TableRow>
        <TableCell colSpan={4}><Typography>{props.group.title}</Typography></TableCell>
    </TableRow>;
};
const QuoteSeparator = (_props: { layoutLocation: number[]; }) => {
    return <TableRow>
        <TableCell colSpan={4}><Divider /></TableCell>
    </TableRow>;
};

const QuoteItemOptions = (props: {
    anchorEl: Element,
    onClose: () => void,
    moveUp: () => void,
    moveDown: () => void,
    addUp: (type: LayoutItemType) => void,
    addDown: (type: LayoutItemType) => void;
}) => {
    const [add, setAdd] = React.useState<{ el: Element, side: 'up' | 'down'; } | undefined>();

    const addItem = () => {
        add?.side === 'up' && props.addUp(LayoutItemType.ITEM);
        add?.side === 'down' && props.addDown(LayoutItemType.ITEM);
        props.onClose();
    };
    const addTitle = () => {
        add?.side === 'up' && props.addUp(LayoutItemType.TITLE);
        add?.side === 'down' && props.addDown(LayoutItemType.TITLE);
        props.onClose();
    };
    const addSeparator = () => {
        add?.side === 'up' && props.addUp(LayoutItemType.SEPARATOR);
        add?.side === 'down' && props.addDown(LayoutItemType.SEPARATOR);
        props.onClose();
    };
    return <>
        {add ? <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={add.el}
            open={!!add}
            onClose={() => { setAdd(undefined); }}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <MenuItem dense onClick={addItem}>Item</MenuItem>
            <MenuItem dense onClick={addTitle}>Titre</MenuItem>
            <MenuItem dense onClick={addSeparator}>Séparateur</MenuItem>
        </Menu> : null}
        <Popover
            open={true}
            onClose={props.onClose}
            anchorEl={props.anchorEl}
            anchorOrigin={{
                vertical: 'center',
                horizontal: 'right'
            }}
            transformOrigin={{
                vertical: 'center',
                horizontal: 'left'
            }}
        ><>
                <ButtonGroup>
                    <Button size='small' onClick={props.moveDown}><KeyboardArrowDown /></Button>
                    <Button size='small' disabled>Déplacer</Button>
                    <Button size='small' onClick={props.moveUp}><KeyboardArrowUp /></Button>
                </ButtonGroup>
                <ButtonGroup>
                    <Button size='small' onClick={(event) => setAdd({ el: event.currentTarget, side: 'down' })}><KeyboardArrowDown /></Button>
                    <Button size='small' disabled>Ajouter</Button>
                    <Button size='small' onClick={(event) => setAdd({ el: event.currentTarget, side: 'up' })}><KeyboardArrowUp /></Button>
                </ButtonGroup>
            </></Popover></>;
};

const QuoteItem = (props: {
    quoteItemId: ModelId,
    layoutLocation: number[],
    moveUp: (location: number[]) => void,
    moveDown: (location: number[]) => void,
    addUp: (type: LayoutItemType, location: number[]) => void,
    addDown: (type: LayoutItemType, location: number[]) => void;
}) => {


    const quoteItem = useSelector((state: AppState) => quoteItemSelector.selectById(state, props.quoteItemId));

    const [menu, setMenu] = React.useState<Element | undefined>();
    if (!quoteItem) return <></>;

    const update = (p: Partial<QuoteItemAttrs>) => {
        appStore.dispatch(quoteItemSlice.actions.updateOne({ id: quoteItem.id, changes: p }));
    };

    return <TableRow>
        <TableCell>
            <Button size='small' onClick={event => setMenu(event.currentTarget)}><MoreHoriz /></Button>
            {menu ? <QuoteItemOptions
                anchorEl={menu}
                onClose={() => setMenu(undefined)}
                addDown={type => props.addDown(type, props.layoutLocation)}
                addUp={type => props.addUp(type, props.layoutLocation)}
                moveDown={() => props.moveDown(props.layoutLocation)}
                moveUp={() => props.moveUp(props.layoutLocation)} /> : null}
        </TableCell>
        <TableCell>
            <SuperSearchInput
                alwaysEditing={true}
                closeOnBlur={false}
                textfieldProps={{
                    label: null,
                    placeholder: "ajouter item / produit / service",
                    variant: 'standard',
                    InputProps: {
                        disableUnderline: true
                    }
                }}
                filter={[AppModels.quoteItems, AppModels.products, AppModels.services]}
                value={(notEmptyString(quoteItem.name) ?? undefined)}
                onItemSelected={(_relatedType: AppModels, _relatedId: ModelId, data: QuoteItemAttrs | ProductAttrs | ServiceAttrs) => {

                    update({
                        relatedType: null,
                        relatedId: null,
                        name: data.name
                    });

                }}
                onSetEmpty={() => {
                    update({
                        relatedType: null,
                        relatedId: null,
                        name: ''
                    });
                }}
                onInputChange={name => {
                    console.log('onInputChange', name);
                    update({
                        name: notEmptyString(name)
                    });
                }}

            /></TableCell>
        <TableCell>
            <ModelTextfield
                variant='standard'
                label={null}
                fullWidth
                InputProps={{
                    disableUnderline: true

                }}
                model={quoteItem}
                modelType={AppModels.quoteItems}
                row='quantity'
                value={quoteItem.quantity}
                onChange={(event) => {
                    const value = parseFloat(event.target.value);
                    if (value) {
                        update({
                            quantity: value
                        });
                    }
                }}
            />
        </TableCell>
        <TableCell>
            <ModelTextfield
                variant='standard'
                label={null}
                fullWidth
                InputProps={{
                    disableUnderline: true
                }}
                model={quoteItem}
                modelType={AppModels.quoteItems}
                row='unitPrice'
                value={quoteItem.unitPrice}
                onChange={(event) => {
                    const value = parseFloat(event.target.value);
                    if (value) {
                        update({
                            unitPrice: value
                        });
                    }
                }}
            />
        </TableCell>
        <TableCell>{quoteItem.quantity && quoteItem.unitPrice ? (quoteItem.quantity * quoteItem.unitPrice).toFixed(2) : ''}</TableCell>
    </TableRow >;
};
